export default {
    apiKey: 'AIzaSyCv1BlcjVn4z978uKxI2dsTT6FZEPoyYTs',
    authDomain: 'camim-e7b0f.firebaseapp.com',
    databaseURL: 'https://camim-e7b0f.firebaseio.com',
    projectId: 'camim-e7b0f',
    storageBucket: 'camim-e7b0f.appspot.com',
    messagingSenderId: '436537785550',
}
